import Vue from 'vue'

/**
 * SweetAlertのtoastを表示する
 * @param {String} icon 表示させるアイコン
 * @param {String} text 表示させるテキスト
 */
function toastAlert (icon, text) {
  Vue.swal({
    icon: icon,
    text: '　' + text,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 5000
  })
}

/**
 * SweetAlertのinfoを表示する
 * @param {String} text 表示させるテキスト
 */
function infoAlert (text) {
  Vue.swal({
    icon: 'info',
    html: `<font size="3" color="#828282">${text}</font>`,
    showConfirmButton: false,
    allowOutsideClick: false
  })
}

export default {toastAlert, infoAlert}



// WEBPACK FOOTER //
// ./src/utils/sweetAlert.js